import PropTypes from 'prop-types';
import React from 'react';
import { useDispatch } from 'react-redux';

import { Menu } from 'common-src/components/base';
import Config from 'common-src/config';
import { apiRequest } from 'common-src/features/rest';
import Patient from 'common-src/models/Patient';
import {
  getPrescriptionConfig,
  PrescriptionProviderOptions,
} from 'common-src/models/PatientCoverage';

import Icons from 'src/assets/Icons';
import { ModalType } from 'src/components/base/ModalGroup';
import { openModal } from 'src/features/modals';
import useCustomSelector from 'src/hooks/useCustomSelector';
import useOpenWindow from 'src/hooks/useOpenWindow';

import styles from '../commonStyles.module.scss';

const PrescriptionProviderMenu = ({ patient, tooltipText }) => {
  const dispatch = useDispatch();

  const { preferredType } = useCustomSelector((state) => getPrescriptionConfig(state, patient?.id));

  const { openWindow } = useOpenWindow();

  const openScriptsureIframe = () =>
    apiRequest({ endpoint: 'clients/scriptsure/login' })
      .then((res) => res.json())
      .then((data) => {
        let url = `${Config.SCRIPTSURE_URL}`;

        if (patient?.scriptsureId) {
          url += `chart/${patient.scriptsureId}/prescriptions`;
        }

        if (data?.sessionToken) {
          url += `?sessiontoken=${data.sessionToken}`;
        }

        openWindow({ url, features: 'width=1200,height=800,left=300,top=100' });
      })
      .catch(() => {
        openWindow({
          url: Config.SCRIPTSURE_URL,
          features: 'width=1200,height=800,left=300,top=100',
        });
      });

  const showCGMOrderPopup = () =>
    dispatch(openModal(ModalType.CGM_ORDER, { patientId: patient.id }));

  const handleOptionSelect = (option) => {
    switch (option.value) {
      case PrescriptionProviderOptions.ePrescription.value:
        openScriptsureIframe();
        break;
      case PrescriptionProviderOptions.faxWrittenOrder.value:
        showCGMOrderPopup();
        break;
      default:
        break;
    }
  };

  const options = Object.values(PrescriptionProviderOptions).map((x) => ({
    ...x,
    label: (
      <div
        id={`link-${x.label}`}
        className="p-12"
        onClick={() => handleOptionSelect(x)}
        role="presentation"
      >
        <span className={[styles.link, 'font-s-12', 'font-w-500'].join(' ')}>{x.label}</span>
        {preferredType === x.value && (
          <span className={[styles.preferred, 'font-s-10', 'font-w-700', 'm-l-20'].join(' ')}>
            preferred
          </span>
        )}
      </div>
    ),
  }));

  return (
    <Menu
      button={
        <img
          id="prescription-provider-button"
          className={[styles.actionButton, 'p-5'].join(' ')}
          src={Icons.rxIcon}
          alt="pill-icon"
        />
      }
      customOptions={options}
      tooltipText={tooltipText}
    />
  );
};

PrescriptionProviderMenu.propTypes = {
  patient: PropTypes.exact(Patient.schema),
  tooltipText: PropTypes.string,
};

export default PrescriptionProviderMenu;
